import { DialogTopSectionWithIcon } from 'components/dialogs/DialogTopSectionWithIcon'
import { LinkOutIcon } from 'components/icons/LinkOut'
import { OpenOutsideIframeButton } from 'components/OpenOutsideIframeButton'
import { useRepository } from 'hooks/auth'
import { useDialogs } from 'hooks/dialogs'
import { useTranslationTyped } from 'i18n/i18n'

/**
 * Rendered in place of a purchase dialog's body when the automatic new tab
 * was blocked. The button is a plain link, so the student's own click always
 * gets through.
 */
export function StripeCheckoutBlockedView({
  headingId,
  checkoutUrl,
}: {
  headingId: string
  checkoutUrl: string
}) {
  const repo = useRepository()
  const { popDialog } = useDialogs()
  const { tt } = useTranslationTyped()

  return (
    <div
      className="flex flex-1 flex-col items-center justify-center"
      data-testid="stripe-checkout-blocked"
    >
      <DialogTopSectionWithIcon
        ColoredIcon={
          <LinkOutIcon size={44} className="stroke-breakout-yellow" />
        }
        title={tt.student_assignment.pay_with_stripe_blocked_title()}
        description={tt.student_assignment.pay_with_stripe_blocked_description()}
        titleId={headingId}
      />
      <OpenOutsideIframeButton
        href={checkoutUrl}
        testId="stripe-checkout-open-new-tab"
        onClick={() => {
          repo.logEvent('stripe_checkout_opened_from_blocked_view')
          popDialog()
        }}
      >
        {tt.student_assignment.pay_with_stripe_blocked_button()}
      </OpenOutsideIframeButton>
    </div>
  )
}
